export const GET_ORDERS = 'src/pages/driverManagement/GET_ORDERS';
export const GET_ORDERS_SUCCESS = 'src/pages/driverManagement/GET_ORDERS_SUCCESS';
export const GET_ORDERS_FAILED = 'src/pages/driverManagement/GET_ORDERS_FAILED';

export const CHANGE_ORDER_STATUS = 'src/pages/driverManagement/CHANGE_ORDER_STATUS';
export const CHANGE_ORDER_STATUS_SUCCESS = 'src/pages/driverManagement/CHANGE_ORDER_STATUS_SUCCESS';
export const CHANGE_ORDER_STATUS_FAILED = 'src/pages/driverManagement/CHANGE_ORDER_STATUS_FAILED';
